import script from "./ProductStockHistoryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductStockHistoryModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductStockHistoryModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__